import type { EpgInfo, TvChannel } from '@setplex/tria-api'
import type { LiveProgramInfo } from './index.h'

import { subHours } from 'date-fns'
import { NO_EPG_ID } from '~/entities/epg/programs'
import { ONE_SECOND_MS } from '~/shared/constants/time'
import { MAX_REWIND_BACK_HOURS } from './index.h'

const formatStartTime = ({
  actualStartMs,
  epgId,
}: Readonly<EpgInfo>): number => {
  const start =
    NO_EPG_ID === epgId
      ? subHours(new Date(), MAX_REWIND_BACK_HOURS).getTime()
      : actualStartMs
  return Math.floor(start / ONE_SECOND_MS)
}

export const formatToView = ({
  channel,
  program,
}: {
  channel: Readonly<TvChannel>
  program: Readonly<EpgInfo>
}): LiveProgramInfo => {
  return {
    logoUrl: channel.logoUrl,
    channelId: channel.id,
    channelTitle: `${channel.channelNumber}. ${channel.name}`,
    programId: program.id,
    programTitle: program.name,
    description: program.description,
    actualStartMs: program.actualStartMs,
    actualStopMs: program.actualStopMs,
    startTime: formatStartTime(program),
  }
}
